export default __webpack_public_path__ + "static/media/refer.5f402e0e.svg";